import React, { useState } from 'react';
import {
  Alert,
  AlertIcon,
  Button,
  ButtonGroup,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Divider,
  FormControl,
  FormHelperText,
  FormLabel,
  Heading,
  Input,
  Stack,
  useColorModeValue,
} from '@chakra-ui/react';
import { getBackendURL, setAndClear, apiFetch } from '../../../utils/utils';
import { useSelector } from 'react-redux';

function PlanForm({ onPlanAdded }) {
  const user = useSelector(state => state.userState.user);
  const [planName, setPlanName] = useState('');
  const [planPrice, setPlanPrice] = useState('');
  const [numberOfMonths, setNumberOfMonths] = useState(0);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [inProgress, setInProgress] = useState(false);

  const onSubmit = () => {
    setError('');
    if (planName === '' || planPrice === '' || numberOfMonths === 0) {
      setError('Please set the proper details');
      return;
    }
    setInProgress(true);
    apiFetch(`${getBackendURL()}/admin/merchant/plans/add`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name: planName,
        price: planPrice,
        numberOfMonths,
        ownerId: user._id,
      }),
    })
      .then(response => response.json())
      .then(response => {
        setPlanName('');
        setPlanPrice('');
        setNumberOfMonths(0);
        setInProgress(false);
        if (response.plan) {
          setAndClear(response.message, setSuccess);
          onPlanAdded();
        } else {
          setAndClear(response.message, setError);
        }
      })
      .catch(error => {
        setInProgress(false);
        setAndClear(error, setError);
      });
  };

  return (
    <Card
      bg={useColorModeValue('white', 'gray.700')}
      data-testid="add-plan-form-card"
    >
      <CardHeader>
        <Heading size="md" data-testid="add-plan-form-heading">
          {'Add Plan'}
        </Heading>
      </CardHeader>
      <Divider />
      <CardBody>
        <Alert status="success" display={success ? 'flex' : 'none'}>
          <AlertIcon />
          {success}
        </Alert>
        <Alert status="error" display={error ? 'flex' : 'none'}>
          <AlertIcon />
          {error}
        </Alert>
        <Stack spacing="4" mt="2">
          <FormControl>
            <FormLabel>Plan Name</FormLabel>
            <Input
              type="text"
              id="plan-name"
              value={planName}
              name="plan-name"
              data-testid="add-plan-field"
              onChange={event => setPlanName(event.target.value)}
            />
          </FormControl>
          <FormControl>
            <FormLabel>Plan Price</FormLabel>
            <Input
              id="plan-price"
              name="plan-price"
              value={planPrice}
              data-testid="add-plan-field"
              onChange={event => setPlanPrice(event.target.value)}
            />
            <FormHelperText>Price of the plan</FormHelperText>
          </FormControl>
          <FormControl>
            <FormLabel>Number of Months</FormLabel>
            <Input
              id="plan-number-of-months"
              value={numberOfMonths}
              data-testid="add-plan-field"
              onChange={event => setNumberOfMonths(event.target.value)}
            />
            <FormHelperText>Validity of the plan in months</FormHelperText>
          </FormControl>
        </Stack>
      </CardBody>
      <Divider />
      <CardFooter>
        <ButtonGroup spacing="2">
          <Button
            variant="solid"
            colorScheme="teal"
            onClick={onSubmit}
            isLoading={inProgress}
            loadingText="Submitting..."
            data-testid="add-plan-submit-button"
          >
            Add Plan
          </Button>
        </ButtonGroup>
      </CardFooter>
    </Card>
  );
}

export default PlanForm;
